/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The MissionControllerDtoBasicInvitedUsersListBasicInvitedUsersListData model module.
 * @module model/MissionControllerDtoBasicInvitedUsersListBasicInvitedUsersListData
 * @version 1.0
 */
class MissionControllerDtoBasicInvitedUsersListBasicInvitedUsersListData {
    /**
     * Constructs a new <code>MissionControllerDtoBasicInvitedUsersListBasicInvitedUsersListData</code>.
     * @alias module:model/MissionControllerDtoBasicInvitedUsersListBasicInvitedUsersListData
     */
    constructor() { 
        
        MissionControllerDtoBasicInvitedUsersListBasicInvitedUsersListData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>MissionControllerDtoBasicInvitedUsersListBasicInvitedUsersListData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/MissionControllerDtoBasicInvitedUsersListBasicInvitedUsersListData} obj Optional instance to populate.
     * @return {module:model/MissionControllerDtoBasicInvitedUsersListBasicInvitedUsersListData} The populated <code>MissionControllerDtoBasicInvitedUsersListBasicInvitedUsersListData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new MissionControllerDtoBasicInvitedUsersListBasicInvitedUsersListData();

            if (data.hasOwnProperty('logNo')) {
                obj['logNo'] = ApiClient.convertToType(data['logNo'], 'Number');
            }
            if (data.hasOwnProperty('inviterAccountNo')) {
                obj['inviterAccountNo'] = ApiClient.convertToType(data['inviterAccountNo'], 'Number');
            }
            if (data.hasOwnProperty('invitedAccountNo')) {
                obj['invitedAccountNo'] = ApiClient.convertToType(data['invitedAccountNo'], 'Number');
            }
            if (data.hasOwnProperty('active')) {
                obj['active'] = ApiClient.convertToType(data['active'], 'Boolean');
            }
            if (data.hasOwnProperty('enabled')) {
                obj['enabled'] = ApiClient.convertToType(data['enabled'], 'Boolean');
            }
            if (data.hasOwnProperty('deletedAt')) {
                obj['deletedAt'] = ApiClient.convertToType(data['deletedAt'], 'Date');
            }
            if (data.hasOwnProperty('createdAt')) {
                obj['createdAt'] = ApiClient.convertToType(data['createdAt'], 'Date');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>MissionControllerDtoBasicInvitedUsersListBasicInvitedUsersListData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>MissionControllerDtoBasicInvitedUsersListBasicInvitedUsersListData</code>.
     */
    static validateJSON(data) {

        return true;
    }


}



/**
 * @member {Number} logNo
 */
MissionControllerDtoBasicInvitedUsersListBasicInvitedUsersListData.prototype['logNo'] = undefined;

/**
 * @member {Number} inviterAccountNo
 */
MissionControllerDtoBasicInvitedUsersListBasicInvitedUsersListData.prototype['inviterAccountNo'] = undefined;

/**
 * @member {Number} invitedAccountNo
 */
MissionControllerDtoBasicInvitedUsersListBasicInvitedUsersListData.prototype['invitedAccountNo'] = undefined;

/**
 * @member {Boolean} active
 */
MissionControllerDtoBasicInvitedUsersListBasicInvitedUsersListData.prototype['active'] = undefined;

/**
 * @member {Boolean} enabled
 */
MissionControllerDtoBasicInvitedUsersListBasicInvitedUsersListData.prototype['enabled'] = undefined;

/**
 * @member {Date} deletedAt
 */
MissionControllerDtoBasicInvitedUsersListBasicInvitedUsersListData.prototype['deletedAt'] = undefined;

/**
 * @member {Date} createdAt
 */
MissionControllerDtoBasicInvitedUsersListBasicInvitedUsersListData.prototype['createdAt'] = undefined;






export default MissionControllerDtoBasicInvitedUsersListBasicInvitedUsersListData;

